
/**
 * 获取文件后缀
 * @param {string} file 文件名
 */
export function getType(file) {
  return file.split('.').pop();
}

/**
 * 加载base
 */
export function loadMsgScript() {
  return new Promise((resolve, reject) => {
    if (document.getElementById("VhallBaseSDK")) {
      resolve(true)
      return;
    }
    let url = "";
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('type', 'text/javascript')
    scriptEl.setAttribute('id', "VhallBaseSDK");
    url = process.env.NODE_ENV === 'production' ? "https://static.vhallyun.com/jssdk/vhall-jssdk-base/vhall-msg-1.0.0.js" : 'https://t-static01-open.e.vhall.com/jssdk/vhall-jssdk-base/vhall-msg-1.0.0.js';
    scriptEl.setAttribute('src', url);
    document.head.appendChild(scriptEl);
    scriptEl.onload = () => resolve(true);
    scriptEl.onerror = () => reject(false);
  });
}


export function formatSeconds(value) {
  var secondTime = parseInt(value);// 秒
  var minuteTime = 0;// 分
  var hourTime = 0;// 小时
  if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  return (hourTime < 10 ? '0' + Math.round(hourTime) : Math.round(hourTime)) + ':' + (minuteTime < 10 ? '0' + Math.round(minuteTime) : Math.round(minuteTime)) + ":" + (secondTime < 10 ? '0' + Math.round(secondTime) : Math.round(secondTime))
}



// 防抖
export function debounce(fn, delay) {
  var timer = null;
  return function () {
    var _this = this;
    var _args = arguments;
    // 清除上一个timer
    clearTimeout(timer);
    // 当最后回调时，经过delay毫秒后执行事件处理程序
    timer = setTimeout(function () {
      fn.apply(_this, _args);
    }, delay);
  }
}

// 节流
export function throttle(fn, delay) {
  var last = 0;
  return function () {
    var cur = +new Date();
    if (cur - last > delay) {
      fn.apply();
      last = cur;
    }
  }
}

export function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}